import { useCallback, useRef, useState } from 'react';

export type GamePreviewState = {
  id: string;
  el: HTMLElement;
} | null;

export function useGamePreview() {
  const [preview, setPreview] = useState<GamePreviewState>(null);

  const timeoutRef = useRef<ReturnType<typeof setTimeout>>(null);
  const dataRef = useRef<GamePreviewState>(null);

  const clearTimoutRef = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }, []);

  const onGameMouseEnter = useCallback(
    (id: string, el: HTMLElement) => {
      const data = { id, el };

      clearTimoutRef();

      if (dataRef.current) {
        setPreview(data);
        dataRef.current = data;
        timeoutRef.current = null;
      } else {
        timeoutRef.current = setTimeout(() => {
          setPreview(data);
          dataRef.current = data;
        }, 165);
      }
    },
    [clearTimoutRef],
  );

  const onGameMouseLeave = useCallback(() => {
    clearTimoutRef();
    timeoutRef.current = setTimeout(() => {
      setPreview(null);
      dataRef.current = null;
    }, 200);
  }, [clearTimoutRef]);

  const onRowMouseLeave = useCallback(() => {
    clearTimoutRef();
    setPreview(null);
    dataRef.current = null;
  }, [clearTimoutRef]);

  return {
    preview,
    onGameMouseEnter,
    onGameMouseLeave,
    onRowMouseLeave,
  };
}
